/**
 * Tasks — module landing.
 *
 * WEEKLY-TASKS-BUILD (Bill 2026-04-25). Currently exposes a single
 * surface: the "Weekly" sub-tab that replaces the legacy SP-hub
 * "FSR/UB Weekly Report" Excel process. This module is intentionally
 * separate from RTM (Retail Task Manager) which handles the
 * pipeline-error / SLA-breach / QC-exception task family. RTM is
 * a transactional task tracker; Tasks/Weekly is a time-boxed,
 * batch-generated work queue.
 *
 * Future tabs (not built today): Daily, Monthly, Ad-hoc — gated behind
 * the same Tasks shell so navigation stays consistent.
 */

import { useState } from 'react';
import { WeeklyTasksTab } from './WeeklyTasksTab';

type TasksSubTab = 'weekly';

export default function Tasks(): JSX.Element {
  const [tab] = useState<TasksSubTab>('weekly');

  return (
    <div style={{ padding: '16px 24px' }}>
      <header style={{ marginBottom: 16 }}>
        <h1 style={{ margin: 0, fontSize: 22, color: 'var(--pcb-blue-dark)', fontWeight: 600 }}>
          Tasks
        </h1>
        <div style={{ marginTop: 8, display: 'flex', gap: 8, borderBottom: '1px solid var(--surface-border)' }}>
          <button
            type="button"
            disabled
            style={{
              border: 0,
              background: 'transparent',
              padding: '8px 12px',
              fontSize: 14,
              color: tab === 'weekly' ? 'var(--pcb-blue)' : 'var(--ink-600)',
              borderBottom: tab === 'weekly' ? '2px solid var(--pcb-blue)' : '2px solid transparent',
              cursor: 'default',
              fontWeight: tab === 'weekly' ? 600 : 500,
            }}
          >
            Weekly
          </button>
        </div>
      </header>
      {tab === 'weekly' && <WeeklyTasksTab />}
    </div>
  );
}
